// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountMenuController from "./account_menu_controller"
application.register("account-menu", AccountMenuController)

import AddressPickerController from "./address_picker_controller"
application.register("address-picker", AddressPickerController)

import BranchFinderController from "./branch_finder_controller"
application.register("branch-finder", BranchFinderController)

import BranchPickerController from "./branch_picker_controller"
application.register("branch-picker", BranchPickerController)

import CardMenuController from "./card_menu_controller"
application.register("card-menu", CardMenuController)

import CartDrawerController from "./cart_drawer_controller"
application.register("cart-drawer", CartDrawerController)

import CheckLineNoteController from "./check_line_note_controller"
application.register("check-line-note", CheckLineNoteController)

import CheckoutSignupController from "./checkout_signup_controller"
application.register("checkout-signup", CheckoutSignupController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HorizontalScrollController from "./horizontal_scroll_controller"
application.register("horizontal-scroll", HorizontalScrollController)

import IdleWatcherController from "./idle_watcher_controller"
application.register("idle-watcher", IdleWatcherController)

import InteractionButtonController from "./interaction_button_controller"
application.register("interaction-button", InteractionButtonController)

import KitchenTimerController from "./kitchen_timer_controller"
application.register("kitchen-timer", KitchenTimerController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LocationConfirmController from "./location_confirm_controller"
application.register("location-confirm", LocationConfirmController)

import LocationModalController from "./location_modal_controller"
application.register("location-modal", LocationModalController)

import ManagerApprovalController from "./manager_approval_controller"
application.register("manager-approval", ManagerApprovalController)

import ManagerApprovalModalController from "./manager_approval_modal_controller"
application.register("manager-approval-modal", ManagerApprovalModalController)

import MarketingContactFormController from "./marketing_contact_form_controller"
application.register("marketing-contact-form", MarketingContactFormController)

import MarketingFaqController from "./marketing_faq_controller"
application.register("marketing-faq", MarketingFaqController)

import MarketingNavController from "./marketing_nav_controller"
application.register("marketing-nav", MarketingNavController)

import MarketingTabsController from "./marketing_tabs_controller"
application.register("marketing-tabs", MarketingTabsController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MoneyInputController from "./money_input_controller"
application.register("money-input", MoneyInputController)

import NewCardAlertController from "./new_card_alert_controller"
application.register("new-card-alert", NewCardAlertController)

import OpsAlertsController from "./ops_alerts_controller"
application.register("ops-alerts", OpsAlertsController)

import OpsFullscreenController from "./ops_fullscreen_controller"
application.register("ops-fullscreen", OpsFullscreenController)

import OpsThemeController from "./ops_theme_controller"
application.register("ops-theme", OpsThemeController)

import OpsToastsController from "./ops_toasts_controller"
application.register("ops-toasts", OpsToastsController)

import PinKeypadController from "./pin_keypad_controller"
application.register("pin-keypad", PinKeypadController)

import PosCheckSizeController from "./pos_check_size_controller"
application.register("pos-check-size", PosCheckSizeController)

import PosGuardedActionController from "./pos_guarded_action_controller"
application.register("pos-guarded-action", PosGuardedActionController)

import PosMobileCheckController from "./pos_mobile_check_controller"
application.register("pos-mobile-check", PosMobileCheckController)

import PosOpenChecksController from "./pos_open_checks_controller"
application.register("pos-open-checks", PosOpenChecksController)

import PosReceiptSendController from "./pos_receipt_send_controller"
application.register("pos-receipt-send", PosReceiptSendController)

import PosSensitiveActionController from "./pos_sensitive_action_controller"
application.register("pos-sensitive-action", PosSensitiveActionController)

import PosSettleController from "./pos_settle_controller"
application.register("pos-settle", PosSettleController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import ProductModalController from "./product_modal_controller"
application.register("product-modal", ProductModalController)

import ScrollMemoryController from "./scroll_memory_controller"
application.register("scroll-memory", ScrollMemoryController)

import ScrollSpyController from "./scroll_spy_controller"
application.register("scroll-spy", ScrollSpyController)

import ServiceCardTimerController from "./service_card_timer_controller"
application.register("service-card-timer", ServiceCardTimerController)

import ServiceKanbanFilterController from "./service_kanban_filter_controller"
application.register("service-kanban-filter", ServiceKanbanFilterController)

import ShiftCountdownController from "./shift_countdown_controller"
application.register("shift-countdown", ShiftCountdownController)

import ThemePickerController from "./theme_picker_controller"
application.register("theme-picker", ThemePickerController)
